import { Outlet } from "react-router-dom";
import { BottomNav } from "./Navigation/BottomNav";

export const MainWrapper = () => {
  return (
    <div className="app-shell">
      <div className="bottom-nav-gradient" />
      <main className="app-content">
        <Outlet />
      </main>

      {/* <BottomNav /> */}
    </div>
  );
};
